<template>
  <div class="login">
    <div class="chooseStyle">
		<p class="welcome">欢迎！{{user.email}}</p>
		<p class="tips">请选择适合您店铺的音乐风格</p>
		<div class="styleList">
			<div :class="['business',active == 0?'active':'']" @click="chooseTab(0)">
				<img src="../assets/shangwu.png" class="busiItem" />
				<p class="nowTitle">商务</p>
			</div>
			<div :class="['relaxation',active == 1?'active':'']"  @click="chooseTab(1)">
				<img src="../assets/xiuxian.png" class="styleItem" />
				<p class="nowTitle">休闲</p>
			</div>
		</div>
		<div class="bottomBox">
			<div class="loginBtn" @click="sureStyle">
				确    定
			</div>
		</div>
	</div>
  </div>
</template>

<script>

import {changeMusicType}  from '../request/api.js'
export default {
  name: 'chooseStyle',
  data(){
	  return{
		 active:'0',
		 user:JSON.parse(localStorage.getItem("userInfo"))
	  }
  },
  components: {
    
  },
  methods:{
	  chooseTab(index){
		  this.active = index;
	  },
	  async sureStyle(){
		  const res = await changeMusicType({
			  musicType:this.active
		  }).then(res => {
			  if(res.code == 0){
				  this.toast("风格选择成功")
				  this.$router.push({
				  	path: '/home'
				  })
				  localStorage.setItem("typeIndex",this.active)
			  }
		  })
	  }
  }
}
</script>
